var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1H3C1.89543 1 1 1.89543 1 3V14.5C1 15.6046 1.89543 16.5 3 16.5H22.5C23.6046 16.5 24.5 15.6046 24.5 14.5V3C24.5 1.89543 23.6046 1 22.5 1Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53773 6.66444C3.01459 6.37751 2.41754 6.14674 1.75 5.98659L1.778 5.86188H4.51498C4.88596 5.87489 5.18699 5.98651 5.28495 6.38071L5.87977 9.21659L6.06198 10.0707L7.72797 5.86188H9.52679L6.85288 12.0275H5.05397L3.53773 6.66444ZM10.85 12.0341H9.14883L10.2128 5.86188H11.9139L10.85 12.0341ZM17.0168 6.01277L16.7854 7.34559L16.6316 7.28004C16.3237 7.15525 15.9174 7.03054 15.3644 7.04371C14.6927 7.04371 14.3915 7.31277 14.3845 7.57546C14.3845 7.86441 14.7489 8.05484 15.3439 8.33725C16.324 8.77719 16.7786 9.31557 16.7718 10.0182C16.7581 11.2986 15.596 12.1261 13.8111 12.1261C13.0479 12.1194 12.3128 11.9681 11.9138 11.7976L12.1519 10.412L12.3759 10.5107C12.9289 10.7407 13.2928 10.839 13.972 10.839C14.4618 10.839 14.9869 10.6484 14.9936 10.2349C14.9936 9.96565 14.7699 9.76851 14.1117 9.46646C13.4678 9.17087 12.6068 8.67848 12.6208 7.79198C12.6281 6.59042 13.8111 5.75 15.491 5.75C16.149 5.75 16.6812 5.88789 17.0168 6.01277ZM19.2778 9.84749H20.6917C20.6218 9.53889 20.2996 8.06147 20.2996 8.06147L20.1807 7.52964C20.0967 7.75943 19.9499 8.13373 19.9569 8.12056C19.9569 8.12056 19.4178 9.4929 19.2778 9.84749ZM21.3776 5.86188L22.75 12.034H21.1749C21.1749 12.034 21.0208 11.3248 20.9719 11.1081H18.7878C18.7246 11.2722 18.4308 12.034 18.4308 12.034H16.6458L19.1726 6.37399C19.3477 5.97342 19.656 5.86188 20.0618 5.86188H21.3776Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visaIcon.5d5deea2897b7834400b275e63d1d06f.svg";
export { ForwardRef as ReactComponent };